module.exports = __webpack_public_path__ + "static/media/alert.6b385037.svg";